<template>
  <div class="student-work">
    <works-com :data-list="studentList" @ScrollCreate="ScrollCreate" @pullingUp="scrollTarget">
      <template v-slot:workShow="ctx1">
        <div class="foot-box">
          <!-- <div class="state">
            <div v-if="ctx1.data.item.cmnt" class="result"> 已批改 </div>
            <div v-else class="reject"> 未批改 </div>
          </div> -->
          <div v-if="ctx1.data.item.comments.length" class="comments">
            <div v-for="(item_com, index_com) in ctx1.data.item.comments" :key="'com'+index_com" class="comment">
              <div class="picture"> <img :src="item_com.pic" alt=""> </div>
              <div class="com-name"> {{ item_com.name }}:</div>
              <div class="com-text"><div> {{ item_com.comment }} </div> <div class="com-text-time"> {{ item_com.time }} </div></div>
            </div>
          </div>
        </div> 
      </template>
    </works-com>
    <div class="btn" @click="goView('/user/add/studentWorks', true)"> 上传作品 </div>
  </div>
</template>

<script>
  import { getArticleList } from '@api/article'
  
  import WorksCom from '@components/content/workBox/worksCom'

  export default {
    name: 'StudentWorks',
    components: { 
      WorksCom
    },
    data() {
      return {
        studentList: [],
        limit: 10,
        page: 1,
        show: false,
        showContent: '',
        videosLength: 0,
        scrollEndOnce: true,
        scroll: null
      }
    },
    methods: {
      /**
       * 页面跳转
       */
      goView(path, state) {
        if (path) {
          if (this.$route.params.uid && state) {
            this.$router.push(path+'/'+ this.$route.params.uid);
          }else if (!state){
            this.$router.push(path);
          }
        }
      },
      getStudentListData() {
        let param = { page: this.page, limit: this.limit }
        getArticleList(this.$route.params.uid, param).then(res => {
          let result = res.data;
          if (result.length) {
            for (let item of result) {
              if (Number(this.$route.params.uid) === Number(item.uid)) {
                this.studentList.push({
                  id: item.id,
                  name: item.student_name,
                  pic: item.headimgurl || require('@assets/images/1.jpg') ,
                  title: item.title,
                  evalPic: item.slider_image,
                  time: item.add_time,
                  praise: item.flowers,
                  praise_state: item.isflower,
                  stars: item.stars,
                  visit: Number(item.visit),
                  status: item.status,
                  cmnt: item.cmnt,
                  comments: this.newEeply(item.reply),
                })             
              }
            }
            this.page++; //获取到数据，下次操作
            if (this.scroll) {
              this.scroll.refresh();
              this.scroll.finishPullUp();
            }
          }else {
            this.$Message.success('已经到底啦');
          }
        })        
      },
      newEeply(reply) { //新reply
        let arr = [];
        if (reply && Array.isArray(reply) && reply.length) {
          arr = reply;
        }else if (reply && typeof(reply) === 'object') {
          for (let prop in reply) {
            let item = reply[prop];
            arr.push({
              name: item.nickname,
              pic: item.headimgurl || require('@assets/images/1.jpg'),
              comment: item.comment,
              time: item.add_time,
              uid: item.uid
            });
          }
        }
        return arr;
      },
      scrollTarget() { //接受上拉操作
        this.getStudentListData();
      },
      ScrollCreate(scroll) { //复制scroll
        this.scroll = scroll;
      }
    },
    mounted() {
      this.getStudentListData();
    }
  }
</script>

<style scoped>
.work-img-box {
  width: 100%;
  padding: 0px 0px 0px 15px;
  border: 10px solid black;
  box-shadow: 3px 3px 5px #5e5e5e, 3px 3px 5px #949494 inset;
  min-height: 100px;
}
  .student-work {
    width: 100vw;
    height: 100vh;
    position: relative;
    background-color: #f5f5f5;
    padding: 0 0.2rem;
    overflow-y: scroll;
  }
    .wrapper {
      height: 100vh;
      overflow: hidden;
    }
      .content {
        padding-bottom: 2rem;
      }
        .evaluate-item {
          width: 100%;
          background-color: white;
          border-radius: 0.15rem;
          margin-top: 0.3rem;
        }
          .user-info {
            padding: 0.3rem;
            width: 100%;
          }
        .show-box {
          display: flex;
          align-items: center;
        }
        .show-content {
          width: 100%;
        }     .result {
                color: #5d8db7;
                margin-top: 0.1rem;
                margin-left: 0.1rem;
                letter-spacing: 0.02rem;
              }
              .reject {
                color: #c36b73;
                margin-top: 0.1rem;
                margin-left: 0.1rem;
                letter-spacing: 0.02rem;
              }
            .comments {
              margin-top: 0.1rem;
              padding-top: 0.05rem;
              border-top: 1px solid #d4d4d4;
            }
              .comment {
                display: flex;
                margin-top: 0.1rem;
              }
                .com-name {
                  margin-right: 0.1rem;
                  font-size: 0.3rem;
                }
                .picture {
                  margin-right: 0.2rem;
                }
                  .picture img {
                    width: 1rem;
                    height: 1rem;
                    border-radius: 50%;
                  }
                .com-text {
                  color: #97999a;
                }
                  .com-text-time {
                    color: #98bee0;
                  }
    .btn {
      width: 40vw;
      height: 0.8rem;
      border-radius: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background-color: #2980f7;
      color: aliceblue;
      position: fixed;
      left: 30vw;
      bottom: 80px;
    }
</style>